// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const Svg = (props: SvgProps) => (
    <svg
        width={props.width?.toString() || '204'}
        height={props.height?.toString() || '180'}
        viewBox='0 0 204 180'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g clipPath='url(#clip0_4397_160033)'>
            <ellipse
                cx='101.25'
                cy='89'
                rx='89.25'
                ry='89.25'
                fill='var(--center-channel-color)'
                fillOpacity='0.08'
            />
            <path
                d='M7.5 75.75L7.5 88.8145L168.261 88.8145L168.261 102.75L192 102.75'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.24'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M151.5 141.75L151.5 119.25L129 119.25'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.24'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <ellipse
                cx='2.25'
                cy='2.25'
                rx='2.25'
                ry='2.25'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 4.5 77.25)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <ellipse
                cx='150.75'
                cy='144'
                rx='2.25'
                ry='2.25'
                transform='rotate(180 150.75 144)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <ellipse
                cx='2.25'
                cy='2.25'
                rx='2.25'
                ry='2.25'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 190.5 104.25)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <path
                d='M100.858 160.405L101.222 160.609L101.588 160.406L109.106 156.227L109.106 156.227C148.812 134.152 157.712 93.1576 161.248 47.6444L161.299 46.9873L160.654 46.8522L160.466 46.8129L160.39 46.797H160.312C141.387 46.797 122.047 39.9873 101.733 21.1994L101.166 20.6749L100.658 21.2572C92.1406 31.0307 84.7227 36.9842 76.2033 40.7408C67.671 44.5031 57.9721 46.0902 44.8319 47.025L44.7996 47.0273L44.7677 47.0323L41.8826 47.4895L41.1953 47.5984L41.2525 48.292C44.981 93.4429 53.7267 134.063 93.0934 156.064L100.858 160.405Z'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
            />
            <path
                d='M43.5 98.25C45.487 104.935 47.8699 111.357 50.748 117.462M52.8704 121.731C57.816 131.172 64.0672 139.782 72.0213 147.346M74.3429 149.481C75.9919 150.947 77.7099 152.37 79.5 153.75'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M101.228 147.75L94.6427 144.164C61.5676 126.159 54.1617 92.9184 51 55.625L53.4468 55.2473C75.7747 53.7002 86.7058 49.9806 101.228 33.75C118.56 49.3634 135.112 55.0605 151.341 55.0605L151.5 55.093C148.502 92.6829 140.965 126.232 107.604 144.298L101.228 147.75Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.12'
            />
            <path
                d='M63.8457 76.668H130.029'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M73.7031 85.1172H139.887'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M66.6621 94.9746H132.846'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M79.3359 111.873H110.316'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M58.2129 68.4072H79.3353'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M83.5605 68.4072H114.54'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M118.764 68.4072H145.519'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M99.0498 120.322H125.805'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M79.3359 120.322H94.8257'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M69.4785 103.017H100.458'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M104.684 103.017H131.439'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M63.8447 60.4746H99.0488'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M104.682 60.4746H139.886'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.12'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M85.5012 85.3311H117.176C118.642 85.3311 119.826 86.51 119.826 87.9712V99.6265C119.826 109.578 115.362 117.647 105.388 117.647H97.2901C87.3156 117.647 82.8516 109.578 82.8516 99.6265V87.9712C82.8516 86.5149 84.0402 85.3311 85.5012 85.3311ZM100.757 92.1353H99.3511V95.4386V101.25L101.216 103.115L99.3511 104.98V107.443H104.454V97.2944L103.028 95.8686L104.454 94.4429V92.1353H100.757Z'
                fill='var(--button-bg)'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M110.061 80.4107V85.3905C110.061 85.4206 110.062 85.4503 110.064 85.4795H114.524C114.527 85.4503 114.528 85.4206 114.528 85.3905V80.4107C114.528 72.9522 109.644 66.8818 102.461 66.8818H99.4189C92.2356 66.8818 87.3516 72.9522 87.3516 80.4107V85.3905C87.3516 85.4206 87.3527 85.4503 87.3549 85.4795H91.8069C91.8091 85.4503 91.8102 85.4206 91.8102 85.3905V80.4107C91.8102 75.3359 94.9858 71.471 98.7523 71.471H103.118C107.136 71.471 110.061 75.3359 110.061 80.4107Z'
                fill='var(--button-bg)'
            />
            <path
                d='M111 23.25C111 23.25 124.759 37.6944 153 42.75'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_4397_160033'>
                <rect
                    width='204'
                    height='178.5'
                    fill='white'
                    transform='translate(0 0.75)'
                />
            </clipPath>
        </defs>
    </svg>
);

export default Svg;
